import hero1 from '../img/heroimg/hero1.png';
import logo1 from '../img/heroimg/logo1.png';

import hero2 from '../img/heroimg/hero2.png';
import logo2 from '../img/heroimg/logo2.png';

import hero3 from '../img/heroimg/hero3.png';
import logo3 from '../img/heroimg/logo3.png';

export const heroImage1 = {
	id: 1,
	img: hero1,
	logo: logo1,
	desc:
		'Geralt of Rivia, a solitary monster hunter, struggles to find his place in a world where people often prove more wicked than beast',
	year: 2019,
	type: 'TV Series'
};

export const heroImage2 = {
	id: 2,
	img: hero2,
	logo: logo2,
	desc:
		'Money Heist is a crime drama on Netflix - originally called La Casa de Papel. Money Heist season 3 has just been released by the streaming service. The plot reads: "Eight thieves take hostages and lock themselves in the Royal Mint of Spain as a criminal mastermind manipulates the police to carry out his plan.',
	year: 2017,
	type: 'TV Series'
};

export const heroImage3 = {
	id: 3,
	img: hero3,
	logo: logo3,
	desc:
		'In Gotham City, mentally troubled comedian Arthur Fleck is disregarded and mistreated by society. He then embarks on a downward spiral of revolution and bloody crime. This path brings him face-to-face with his alter-ego: the Joker.',
	year: 2019,
	type: 'Movies'
};
